import React from 'react';

import ViewAssociation from 'screens/associations/ViewAssociation';

const ViewAssociationScreen = () => <ViewAssociation />;

export default ViewAssociationScreen;
